module.exports = __webpack_public_path__ + "img/map-pin.8133f04.png";